// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js?importLoaders=1!../../../node_modules/postcss-loader/index.js?config=node_modules/object-partners-presentation/dist/config-files/postcss.config.js!../../../node_modules/sass-loader/lib/loader.js!./slide-deck.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?importLoaders=1!../../../node_modules/postcss-loader/index.js?config=node_modules/object-partners-presentation/dist/config-files/postcss.config.js!../../../node_modules/sass-loader/lib/loader.js!./slide-deck.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?importLoaders=1!../../../node_modules/postcss-loader/index.js?config=node_modules/object-partners-presentation/dist/config-files/postcss.config.js!../../../node_modules/sass-loader/lib/loader.js!./slide-deck.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/style-loader!./~/css-loader?importLoaders=1!./~/postcss-loader?config=node_modules/object-partners-presentation/dist/config-files/postcss.config.js!./~/sass-loader/lib/loader.js!./src/components/slide-deck/slide-deck.scss
// module id = 246
// module chunks = 1